import React from 'react'
import styled from '@emotion/styled'

import CatalogTopBar from '../CatalogTopBar'
import CatalogSidebar from '../CatalogSidebar'
import GoodList from '../GoodList'

const Root = styled.div`
  display: flex;
`

const Aside = styled.aside`
  max-width: 250px;
  padding: 71px 23px 20px 21px;
  flex-shrink: 0;
`

const Main = styled.div`
  flex: 1;
  margin-right: 22px;
`

const Title = styled.h2`
  margin: 20px 0 20px 0;
  color: #ec2323;
  font-family: Merriweather, serif;
  font-size: 22px;
  font-weight: 400;
`

const CatalogPageLayout = ({
  currentUser,
  activeCatalogType,
  activeCategory,
  categoriesByCatalogTypeNames,
  searchQuery,
  setSearchQuery,
  viewType,
  setViewType,
  sortOptions,
  sort,
  setSort,
  cart,
  setQuantityInCart
}) => <Root>
  <Aside>
    <CatalogSidebar
      activeCategory={activeCategory}
      activeCatalogType={activeCatalogType}
      categoriesByCatalogTypeNames={categoriesByCatalogTypeNames}
    />
  </Aside>
  <Main>
    <Title>{activeCatalogType.getCatalogTitle(activeCategory)}</Title>
    <CatalogTopBar
      activeCatalogType={activeCatalogType}
      activeCategory={activeCategory}
      searchQuery={searchQuery}
      setSearchQuery={setSearchQuery}
      viewType={viewType}
      setViewType={setViewType}
      sortOptions={sortOptions}
      sort={sort}
      setSort={setSort}
    />
    <GoodList
      currentUser={currentUser}
      activeCatalogType={activeCatalogType}
      activeCategory={activeCategory}
      searchQuery={searchQuery}
      viewType={viewType}
      sort={sort}
      cart={cart}
      setQuantityInCart={setQuantityInCart}
    />
  </Main>
</Root>

export default CatalogPageLayout
